<div class="filter-top-bar">
  <div class="filter-wrapper">
    <div class="filter-tabs-holder align-items-center">
      <div class="search-holder">
        <input type="search" placeholder="Search by anything" class="form-control table-search" [formControl]="searchControl" />
        <span class="icon-search"></span>
      </div>
      <div *ngIf="showUsers" class="filter-tab">
        <a class="dropdown-toggle" role="button" [dropdown]="usersContent">
          Users <span *ngIf="usersCollection.length">({{usersCollection.length}})</span>
        </a>
        <ng-template #usersContent let-dropdown="dropdown">
          <div class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
            <div class="user-filter-drop">
              <app-users-select [multiple]="true" (clear)="onClear('users');dropdown.hide()" (selectUser)="onSelectUser($event)"
                (unSelectUser)="onUnSelectUser($event)">
              </app-users-select>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="filter-tab">
        <a class="dropdown-toggle" [ngClass]="{'active': model.from && model.to}" role="button" [dropdown]="dateContent">
          Date
        </a>
        <ng-template #dateContent let-dropdown="dropdown">
          <div class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
            <div class="date-filter-drop mx-15">
              <input-search-period type="date" [autoApply]="true" (change)="onChangeDate($event)" [placeholder]="'Date'">
              </input-search-period>
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button class="btn mr-10" (click)="onClear('date');dropdown.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onSubmitClick();dropdown.hide();">Submit</button>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="filter-tab">
        <a class="dropdown-toggle" [ngClass]="{'active': !!model.testGroupId}" role="button" [dropdown]="testGroupIdContent">
          Test group id
        </a>
        <ng-template #testGroupIdContent let-dropdown="dropdown">
          <div class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1">
            <div class="date-filter-drop mx-15">
              <input type="number" placeholder="Test group id" class="form-control" [(ngModel)]="model.testGroupId" />
            </div>
            <hr>
            <div class="d-flex justify-content-end mx-10">
              <button class="btn mr-10" (click)="onClear('testGroupId');dropdown.hide();">Clear</button>
              <button class="btn btn-primary" (click)="onSubmitClick();dropdown.hide();">Submit</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="filter-right-col">
    <a class="filter-delete-btn me-15" (click)="onClearAllFilter()">
      <span class="far fa-trash-alt me-10"></span>
      <span>Clear filters</span>
    </a>
    <button class="rounded-icons" (click)="onClickExport()" [tooltip]="getTooltipContent()" [tooltipPlacement]="'top'">
      <span class="icon-export"></span>
    </button>
  </div>
</div>


<ng-template #exportModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Export</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!exportSpinner" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div *ngIf="!exportData.filename">
      <p>Select size:</p>
      <div class="export-option-container" *ngFor="let size of exportSizes" (click)="exportSize = size">
        <input class="form-check-input cp" type="radio" name="exportSize" [value]="size" [(ngModel)]="exportSize" />
        <input *ngIf="size === 'Custom'" class="form-control" type="number" [(ngModel)]="customExportSize" />
        <label *ngIf="size !== 'Custom'" class="form-check-label cp"> {{size}} </label>
      </div>
    </div>
    <div class="pb-20" *ngIf="customExportSize < 1">
      <span class="text-error-r2">Cannot export less than 1 row.</span>
    </div>
    <div *ngIf="exportData.filename">
      <br>
      File: <strong style="overflow-wrap: break-word;">{{ exportData.filename }}</strong><br><br>
      <div class="text-center mb-15">
        <div class="hr-line-dashed"></div>
        <a href="{{ exportData.download_url }}" target="_blank" class="btn btn-primary">Download</a>
      </div>
    </div>
  </div>
  <div class="modal-footer pt-15" *ngIf="!exportData.filename">
    <div class="button-holder d-flex justify-content-between">
      <button [disabled]="exportSpinner" class="btn btn-outline-dark" (click)="dialogRef.close(true)">Cancel</button>
      <button [disabled]="exportSpinner || customExportSize < 1" class="btn btn-primary" (click)="export(exportSize)">
        <span class="icon-export"></span> Export
      </button>
    </div>
  </div>
</ng-template>
